import React from 'react';
import DOMPurify from 'dompurify';
import isEmpty from 'lodash.isempty';
import loadable from '@loadable/component';

// api
import newsApi from '/src/apis/newsApi';
import researchApi from '/src/apis/researchApi';

// helpers and constants
import { getItemWebUrl, timeDiff, trimText } from '/src/utilities/helpers';

// reusable
import Slider from './Slider';
import Skeleton from 'react-loading-skeleton';

const ContentTag = loadable(() =>
    import(/* webpackChunkName: "ContentTag" */ '/src/reusable-components/ContentTag'),
);



export default class RelatedArticles extends Slider {

    componentDidMount() {
        const { itemId, type } = this.props;
        if (itemId && type) {
            const getRelatedItems = (type === "news" ? newsApi.getRelatedNews : researchApi.getRelatedResearch);
            getRelatedItems(itemId).then(
                response => {
                    this.setState({
                        item: response,
                        limit: response.length,
                        noRelatedItems: response.length === 0,
                        removeSkeleton: true,
                    });
                    this.initializeSlider();
                    this.moveSlider(); // init
                }
            )
        }
    }

    render() {

        const { displayCount, type } = this.props;
        const { item, limit, itemSlider, fadeClass, slider, noRelatedItems } = this.state;
        const showSliderButtons = item.length > displayCount;


        if (noRelatedItems === true) {
            return null;
        }

        return (
            <div className="related-items-section" >
                <div className="db-header mb-0">
                    <p className="heading-1">Related {type === "news" ? 'Articles' : 'Reports'}</p>
                    {showSliderButtons &&
						<div className="slider-btn-row">

						    {/* back button */}
						    {slider?.start > 0 ?
						        <div className="slider-btn" onClick={() => this.moveSlider("prev")}>
						            <i className="fas fa-chevron-left"></i>
						        </div>
						        :
						    // disabled
						        <div className="slider-btn">
						            <i className="fas fa-chevron-left disabled"></i>
						        </div>
						    }

						    {/* next button */}
						    {slider?.end < (limit - 1) ?
						        <div className="slider-btn" onClick={() => this.moveSlider("next")}>
						            <i className="fas fa-chevron-right"></i>
						        </div>
						        :
						    // disabled
						        <div className="slider-btn">
						            <i className="fas fa-chevron-right disabled"></i>
						        </div>
						    }

						</div>
                    }
                </div>
                <div>
                    {(this.state.removeSkeleton) ?
                        <div className="content-item-row slider-widget row">
                            {itemSlider.map((item, i) => {
                                if (!isEmpty(item.image_data)) {
                                    item.image = encodeURI(item.image_data.path)
                                }
                                if (type === "news" && item.title.length > 100) {
                                    item.title = item.title.substring(0, 100) + '...'
                                }

                                let itemUrl = getItemWebUrl(type, item.id, item.code);

                                let timePeriod = "";
                                let time = "";
                                if (item.published_at) {
                                    timePeriod = timeDiff(item.published_at) + " ago";
                                    let date = new Date(item.published_at)
                                    let options = { year: 'numeric', month: 'short', day: 'numeric' };
                                    time = date.toLocaleString("en-US", options);
                                }

                                // trim body
                                let body = '';
                                if (type === "news") {
                                    body = `<p>${trimText(item.body)}</p>`;
                                } else {
                                    body = `<p>${trimText(item.short_description)}</p>`;
                                }

                                return (
                                    <div key={i} onClick={() => { this.amplitudeTrack('research - clicked data insights to news') }} className={"slider-item " + fadeClass} lang={item.lang ? item.lang : "en"}>
                                        <div className="slider-row">
                                            <a href={`/${itemUrl}`} aria-label={`${item.title}-Image` || 'Related-Reports-Image'}>
                                                <img
                                                    src={item.image}
                                                    alt={`${item.title}-Image` || 'Related-Reports-Image'}
                                                    onError={(event) => this.imgMissing(event, item)}
                                                    loading="lazy"
                                                />
                                            </a>
                                            <div className="content-item-row-text">
                                                <div className="content-item-row-title">
                                                    <a href={`/${itemUrl}`} className="no-underline">
                                                        {type === "news" ? item.title : item.name}
                                                    </a>
                                                </div>
                                                <div className="content-item-row-desc mb-0"
                                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }}>
                                                </div>
                                                <div className="content-item-row-secondary">
                                                    {time && timePeriod ? `Posted ${timePeriod} - ${time}` : 'Unpublished'}
                                                </div>
                                                <ContentTag tagdata={item} type={type} displayMax={2} />
                                            </div>
                                        </div>
                                    </div>
                                )

                            })}
                        </div>
                        :
                        <div className="content-item-row slider-widget row" >
                            {[...Array(displayCount)].map((_, index) => (
                                <div className="slider-item" key={index}>
                                    <Skeleton height={'550.74px'} width={'100%'} />
                                </div>
                            ))}
                        </div>}
                </div>
            </div >
        );

    }
}
